@let n = notification();
@if (n) {
    @if (n.childItems) {
        <div class="pnyc-notification-group pnyc-notification-group--opened">

            <div class="pnyc-notification-group-inner">

                <div class="pnyc-notification-group-content">

                    <header class="pnyc-notification-group-header">

                        <div class="pnyc-notification-icon-wrap" [pnycBadge]="n.totalCount ?? n.childItems.length">

                            @if(!n.notificationIconName) {
                                <pnyc-avatar class="pnyc-notification-avatar" [profileImageUrl]="n.imageUrl ?? ''"
                                    [userFullName]="n.fullName ?? ''" [useBackgroundImage]="true">
                                </pnyc-avatar>
                            } @else {
                                <pnyc-icon class="pnyc-notification-icon" [iconName]="n.notificationIconName">
                                </pnyc-icon>
                            }

                        </div>

                        <div class="pnyc-notification-group-header-info">
                            <div class="pnyc-notification-group-header-info-title">
                                @if (n.customerProfileUrl && n.isCustomer) {
                                    <span class="pnyc-notification-customer-name"
                                        (click)="onCustomerNameClick($event, n.customerProfileUrl)">{{
                            n.groupTitle }}</span>
                                } @else {
                                    {{ n.groupTitle }}
                                }
                            </div>

                            <div class="pnyc-notification-group-header-info-date">
                                {{ 'NOTIFICATION.TITLES.LATEST_UPDATE' | translate }} {{ n.notificationDate | date:
                        dateFormat }}
                            </div>
                        </div>

                        <div class="pnyc-notification-status-btn-wrap"
                            [class.pnyc-notification-status-btn-wrap--new]="!isGroupViewed"
                            (click)="onMarkAsRead($event, n.id, true)">
                            <div class="pnyc-notification-status-btn">
                            </div>
                        </div>

                    </header>

                    @if (childItems && childItems.length > 0) {
                        <div class="pnyc-notification-group-body">

                            <div class="pnyc-notification-group-list-wrap">

                                <div class="pnyc-notification-group-list">

                                    @for(item of childItems; track item) {
                                        <ng-container [ngTemplateOutlet]="notificationTemplate"
                                            [ngTemplateOutletContext]="{ item, isChild: true }">
                                        </ng-container>
                                    }

                                </div>

                            </div>

                        </div>
                    }

                    @if (hasMoreItems) {
                        <footer class="pnyc-notification-group-footer">
                            <div class="pnyc-notification-group-footer-btn" (click)="toggleCollapsed.emit()">
                                {{ 'NOTIFICATION.TITLES.SHOW_MORE' | translate }}
                            </div>
                        </footer>
                    }

                </div>

                @if (n.isCollaboration) {
                    <div class="pnyc-notification-decoration" [style.--decoration-bg]="backgroundImage()">
                    </div>
                }

            </div>

        </div>
    } @else {
        <ng-container [ngTemplateOutlet]="notificationTemplate" [ngTemplateOutletContext]="{ item: n, isChild: false }">
        </ng-container>
    }
}

<ng-template #notificationTemplate let-item="item" let-isChild="isChild">
    @if(item) {
        <a class="pnyc-notification-item" [class.pnyc-notification-item--disabled]="item.isRemovedAccount"
            (click)="onRedirect(item)">

            <div class="pnyc-notification-item-inner">

                <div class="pnyc-notification-item-content" [class.pnyc-notification-item-content--child]="isChild">

                    @if(!item.notificationIconName && !isChild) {
                        <div class="pnyc-notification-icon-wrap">
                            <pnyc-avatar class="pnyc-notification-avatar" [profileImageUrl]="item.imageUrl ?? ''"
                                [userFullName]="item.fullName ?? ''">
                            </pnyc-avatar>
                        </div>
                    }

                    @if(item.notificationIconName && !isChild) {
                        <div class="pnyc-notification-icon-wrap">
                            <pnyc-icon class="pnyc-notification-icon" [iconName]="item.notificationIconName">
                            </pnyc-icon>
                        </div>
                    }

                    <div class="pnyc-notification-item-info">

                        <div class="pnyc-notification-item-info-title">
                            @if (item.customerProfileUrl && item.fullName && item.title.includes(item.fullName)) {
                                @for (part of getTitleParts(item.title, item.fullName); track $index) {
                                    @if (part === item.fullName) {
                                        <span class="pnyc-notification-customer-name"
                                            (click)="onCustomerNameClick($event, item.customerProfileUrl)">{{ part }}</span>
                                    } @else {
                                        {{ part }}
                                    }
                                }
                            } @else {
                                {{ item?.title }}
                            }
                        </div>

                        @if(item.subtitle) {
                            <div class="pnyc-notification-item-info-subtitle">

                                @if(item.subtitleIconName) {
                                    <pnyc-icon class="pnyc-notification-item-info-subtitle-icon"
                                        [class]="item.subtitleIconClass" [iconName]="item.subtitleIconName">
                                    </pnyc-icon>
                                }

                                <div class="pnyc-notification-item-info-subtitle-text">{{ item.subtitle }}</div>

                            </div>
                        }

                        @if(item.date) {
                            <div class="pnyc-notification-item-info-range">

                                @if(item.dateIcon) {
                                    <pnyc-icon class="pnyc-notification-item-info-range-icon"
                                        [iconName]="item.dateIcon">
                                    </pnyc-icon>
                                }

                                <div class="pnyc-notification-item-info-range-date">{{ item.date }}
                                </div>

                            </div>
                        }

                        @if(item.text) {
                            <div class="pnyc-notification-item-info-state-wrap">
                                <div class="pnyc-notification-item-info-state" [class]="item.textClassName">

                                    @if(item.textIconName) {
                                        <pnyc-icon class="pnyc-notification-item-info-state-icon"
                                            [iconName]="item.textIconName">
                                        </pnyc-icon>
                                    }

                                    <div class="pnyc-notification-item-info-state-text">{{ item.text }}</div>

                                </div>
                            </div>
                        }

                        @if(item.actions) {
                            <div class="pnyc-notification-item-info-actions">
                                @for(action of item.actions; track action) {
                                    <pnyc-button [iconName]="action.iconName" [customClass]="action.customClass"
                                        [text]="action.title" (clicked)="action.action(); $event.stopPropagation()">
                                    </pnyc-button>
                                }
                            </div>
                        }

                        <div class="pnyc-notification-item-info-date-wrap">

                            <div class="pnyc-notification-item-info-date">{{ item.notificationDate | date: dateFormat }}
                            </div>

                            @if(item.isCollaboration) {
                                <div
                                    class="pnyc-divider pnyc-divider--vertical pnyc-notification-item-info-date-divider">
                                </div>

                                <div class="pnyc-notification-item-info-date-logo">
                                    <pnyc-icon class="pnyc-notification-item-info-date-logo-icon"
                                        [iconName]="'hexagon'">
                                    </pnyc-icon>

                                    <div class="pnyc-notification-item-info-date-logo-text">myPlaceNYC</div>
                                </div>
                            }
                        </div>

                    </div>

                    <div class="pnyc-notification-status-btn-wrap"
                        [class.pnyc-notification-status-btn-wrap--new]="!item.isViewed"
                        (click)="onMarkAsRead($event, item.id, false)">
                        <div class="pnyc-notification-status-btn">
                        </div>
                    </div>

                </div>

                @if (n?.isCollaboration && !isChild) {
                    <div class="pnyc-notification-decoration" [style.--decoration-bg]="backgroundImage()">
                    </div>
                }

                @if (item.isRegistered) {
                    <img class="pnyc-notification-congrats" src="assets/images/decoration/notifications/congrats.webp"
                        alt="">
                }

            </div>

        </a>
    }
</ng-template>